import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {
  private isToastVisible = false;
  private readonly TOAST_LIFE = 5000; // Must match the life of the toast in the interceptor

  constructor(private messageService: MessageService) { }

  /**
   * Shows an error toast, but only if one is not already visible.
   * This prevents multiple toasts from appearing for concurrent failed API calls.
   * @param summary The title of the error message.
   * @param detail The detailed error message.
   */
  public showError(summary: string, detail: string): void {
    // If a toast is already visible, do nothing.
    if (this.isToastVisible) {
      return;
    }

    // Set the flag to true to indicate a toast is now visible.
    this.isToastVisible = true;

    // Show the toast message.
    this.messageService.add({
      key: 'global',
      severity: 'error',
      summary: summary,
      detail: detail,
      life: this.TOAST_LIFE
    });

    // After the toast's duration, reset the flag to allow new toasts to be shown.
    setTimeout(() => {
      this.isToastVisible = false;
    }, this.TOAST_LIFE);
  }
}
